import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "How secure is parking through Bayzo?",
      answer: "All parking spots on Bayzo are verified and many include security features like CCTV, lighting, and gated access. We also provide insurance coverage for your vehicle during the rental period and have a 24/7 support team to assist with any issues."
    },
    {
      question: "What if I need to cancel my booking?",
      answer: "You can cancel your booking up to 1 hour before your reserved time for a full refund. Cancellations made less than 1 hour before the booking time may incur a small cancellation fee. Emergency cancellations are handled on a case-by-case basis."
    },
    {
      question: "How do I access the parking spot?",
      answer: "Once your booking is confirmed, you'll receive detailed access instructions including the exact location, any access codes or keys, and contact information for the spot owner. Most spots have clear signage and are easily accessible."
    },
    {
      question: "What if the parking spot is occupied when I arrive?",
      answer: "If your reserved spot is occupied, contact our support team immediately through the app. We'll work to resolve the issue quickly, either by contacting the spot owner or finding you an alternative nearby spot at no extra charge."
    },
    {
      question: "Are there size restrictions for vehicles?",
      answer: "Each parking spot listing includes detailed information about size restrictions, including length, width, and height limits. Make sure to check these details before booking. Most spots accommodate standard cars, but larger vehicles should verify dimensions first."
    },
    {
      question: "How do payments work?",
      answer: "Payment is processed securely through our platform when you make a booking. We accept all major credit cards and digital payment methods. Payment is held in escrow and released to the spot owner after your parking period ends successfully."
    },
    {
      question: "Can I extend my parking time?",
      answer: "Yes, you can extend your parking time through the app if the spot is available for longer. Additional time is charged at the same hourly rate. We recommend extending early as spots may become unavailable for longer periods."
    },
    {
      question: "What if I'm running late or early?",
      answer: "Most spot owners offer a 15-30 minute grace period. If you're running significantly late or early, use the in-app messaging feature to communicate with the spot owner. Many are flexible and accommodating with timing adjustments."
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Get answers to common questions about parking with Bayzo
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-background rounded-lg border px-6"
              >
                <AccordionTrigger className="text-left hover:no-underline">
                  <span className="font-medium">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            Still have questions? We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            >
              Contact Support
            </a>
            <a
              href="mailto:support@bayzo.com"
              className="inline-flex items-center justify-center px-6 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
            >
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;